import React from "react";

const ViewModal = () => {
  return <div>ViewModal</div>;
};

export default ViewModal;
